import { render, staticRenderFns } from "./client_history.vue?vue&type=template&id=a8c1e4d6&scoped=true&"
import script from "./client_history.vue?vue&type=script&lang=js&"
export * from "./client_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c1e4d6",
  null
  
)

export default component.exports